import React from 'react';
import { Button } from '../Button';
import { InputGroup } from '../InputGroup/InputGroup';
import { addFilterButtonDataAttribute } from './DataAttributes';
var locale = {
  add: 'Add'
};
export var FilterTextMultiFilterSuffix = function FilterTextMultiFilterSuffix(_ref) {
  var disabled = _ref.disabled,
      queryOperator = _ref.queryOperator,
      onClick = _ref.onClick;
  return React.createElement(InputGroup.Suffix, {
    size: "small"
  }, React.createElement(Button.Neutral.Small, {
    dataTest: addFilterButtonDataAttribute,
    disabled: disabled,
    onClick: onClick
  }, locale.add));
};